import { createApi } from "@reduxjs/toolkit/query/react";
import { BaseQueryWithReAuth, NFMS_TAG_TYPES } from "../utils";
import { generalEndpoints } from "./endpoints/main";
import { feederMasterDataEndpoints } from "./endpoints/feeder-master-data";
import { nfmsLogsEndpoints } from "./endpoints/nfms-logs";
import { realTimeAlarmsSyncNFMSEndpoints } from "./endpoints/real-time-alarms-sync";
import { blockLoadSyncEndpoints } from "./endpoints/block-load-sync";

export const hesBaseQuery = BaseQueryWithReAuth({
  baseUrl: `${import.meta.env.VITE_NFMS_BASE_URL}/`,
  credentials: "same-origin",
  setHeaders: (headers) => {
    headers.set(
      "Authorization",
      `Bearer ${localStorage.getItem("accessToken") || ""}`
    );
    return headers;
  }
});

const nfmsApi = createApi({
  reducerPath: "nfmsApi",
  baseQuery: hesBaseQuery,
  tagTypes: NFMS_TAG_TYPES,
  endpoints: (builder) => ({
    ...generalEndpoints(builder),
    ...feederMasterDataEndpoints(builder),
    ...nfmsLogsEndpoints(builder),
    ...realTimeAlarmsSyncNFMSEndpoints(builder),
    ...blockLoadSyncEndpoints(builder)
  })
});

export const {
  useGetNfmsFilterDataQuery,
  useGetFeederMasterListViewMutation,
  useGetNFMSSuccessLogsMutation,
  useGetNFMSFailedLogsMutation,
  useGetRealTimeAlarmsSyncNFMSMutation,
  useGetBlockLoadSyncListViewMutation,
  useGetBlockLoadFailedListViewQuery,
  usePrefetch
} = nfmsApi;

export default nfmsApi;
